<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <div class="flex justify-end gap-2">
        <period-select v-model="filter.period_id" @change="onFilter" />
      </div>
      <datatable
        :columns="tableColumns"
        :total="balanceSummaries.meta.page.total"
        :perPage="balanceSummaries.meta.page.perPage"
        :currentPage="balanceSummaries.meta.page.currentPage"
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="balanceSummary in balanceSummaries.data"
            :key="balanceSummary.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">
              {{ balanceSummary.attributes.office_code }}
            </td>
            <td :class="classes.td">
              {{ balanceSummary.attributes.office_name }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ balanceSummary.attributes.total_order_price | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ balanceSummary.attributes.total_payment_amount | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ balanceSummary.attributes.balance | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ balanceSummary.attributes.debt | toCurrency }}
            </td>
          </tr>

          <tr v-if="balanceSummaries.data.length">
            <td></td>
            <td :class="[classes.td]">Total</td>
            <td :class="[classes.td, 'text-right']">
              {{ summary.total_order_price | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ summary.total_payment_amount | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ summary.balance | toCurrency }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{ summary.debt | toCurrency }}
            </td>
          </tr>
        </template>
      </datatable>
    </div>
  </base-wrapper>
</template>

<script>
import PeriodSelect from '@/components/period/period-select.vue';
import { requestMixin } from '@/mixins/request/request';

export default {
  mixins: [requestMixin],
  components: { PeriodSelect },
  data() {
    return {
      currentPeriod: {
        data: {
          attributes: {},
        },
      },
      filter: {
        period_id: null,
      },
      loadingBalanceSummaries: false,
      loadingCurentPeriod: false,
      loadingPeriodSummary: false,
      balanceSummaries: {
        data: [],
        meta: {
          page: {},
        },
      },
      summary: {
        total_order_price: 0,
        total_payment_amount: 0,
        balance: 0,
        debt: 0,
      },
    };
  },
  computed: {
    loading() {
      return (
        this.loadingCurentPeriod ||
        this.loadingBalanceSummaries ||
        this.loadingPeriodSummary
      );
    },
    tableColumns() {
      return [
        {
          id: 'office_code',
          name: 'Stockist',
        },
        {
          id: 'office_name',
          name: 'Pengelola Stockist',
        },
        {
          id: 'sum_order_final_price',
          name: 'Belanja',
          theadClass: 'text-right',
        },
        {
          id: 'sum_payment_amount',
          name: 'Pembayaran',
          theadClass: 'text-right',
        },
        {
          id: 'office_balance',
          name: 'Saldo',
          theadClass: 'text-right',
        },
        {
          id: 'office_debt',
          name: 'Kurang Bayar',
          theadClass: 'text-right',
        },
      ];
    },
  },
  methods: {
    async loadCurrentPeriod() {
      this.loadingCurentPeriod = true;

      const [res, err] = await this.request(
        '/api/v1/periods/-actions/get-current-period'
      );

      if (!err) {
        this.currentPeriod = res;

        this.filter.period_id = res.data.id;
      }

      this.loadingCurentPeriod = false;
    },
    async loadBalanceSummaries(params) {
      this.loadingBalanceSummaries = true;

      const [res, err] = await this.request(
        '/api/v1/office-balance-summaries',
        {
          params: {
            'filter[period_uuid]': this.filter.period_id,
            'filter[balance_type]': 'stockist_balance',
            'page[size]': 10,
            ...params,
          },
        }
      );

      if (!err) {
        this.balanceSummaries = res;
      }

      this.loadingBalanceSummaries = false;
    },
    async loadPeriodSummary() {
      this.loadingPeriodSummary = true;

      const [res, err] = await this.request(
        `/api/v1/periods/${this.filter.period_id}/office-category-summaries`,
        {
          params: {
            'filter[office_category_id]': 4,
            'page[size]': 10,
          },
        }
      );

      if (!err) {
        if (res.data.length) {
          const [summary] = res.data;

          this.summary.total_order_price = summary.attributes.total_order_price;
          this.summary.total_payment_amount =
            summary.attributes.total_payment_amount;
          this.summary.balance = summary.attributes.balance;
          this.summary.debt = summary.attributes.debt;
        } else {
          this.summary.total_order_price = 0;
          this.summary.total_payment_amount = 0;
          this.summary.balance = 0;
          this.summary.debt = 0;
        }
      }

      this.loadingPeriodSummary = false;
    },
    onChangePage(page) {
      this.loadBalanceSummaries({
        'page[number]': page,
      });
    },
    onFilter() {
      this.loadBalanceSummaries();
      this.loadPeriodSummary();
    },
  },
  async created() {
    await this.loadCurrentPeriod();
    this.loadBalanceSummaries();
    this.loadPeriodSummary();
  },
};
</script>
